import { BannerComponentId } from "../banner/bannerComponentId";
import {
  teamAfterFirstFailureBannerContent,
  changesAfterFirstFailureBannerContent,
} from "./utils/ErrorBannerMessages";

const bannerComponent = (componentId: BannerComponentId): JSX.Element => {
  switch (componentId) {
    case BannerComponentId.CreateTeamAfterFirstFailure:
      return teamAfterFirstFailureBannerContent("created");
    case BannerComponentId.MoveTeamAfterFirstFailure:
      return teamAfterFirstFailureBannerContent("moved");
    case BannerComponentId.DeleteTeamFailure:
      return teamAfterFirstFailureBannerContent("deleted");
    case BannerComponentId.ChangesAfterFirstFailure:
      return changesAfterFirstFailureBannerContent;

    default:
      throw new Error("Invalid component id!");
  }
};

export default bannerComponent;
